import { authenticatedApi } from '../../../shared/api/apiClientUtils.ts';

export interface CreateLabourItemGroupRequest {
  name: string;
  labourItemDefinitionIds?: string[];
}

export interface CreateLabourItemGroupResponse {
  id: string;
  name: string;
  labourItemCount: number;
}

export interface UpdateLabourItemGroupRequest {
  name: string;
  labourItemDefinitionIds?: string[];
}

export interface UpdateGroupLabourItemsRequest {
  labourItemDefinitionIds: string[];
}

export interface LabourItemGroup {
  id: string;
  name: string;
  labourItemCount: number;
  itemNamePreview: string[];
}

export interface LabourItemGroupDetails {
  id: string;
  name: string;
  labourItems: LabourItemDefinition[];
}

export interface LabourItemDefinition {
  id: string;
  name: string;
}

export const createLabourItemGroup = async (
  request: CreateLabourItemGroupRequest
): Promise<CreateLabourItemGroupResponse> => {
  const response = await authenticatedApi.post<CreateLabourItemGroupResponse>(
    '/api/v1/labour-items/groups',
    request
  );

  return response.data;
};

export const getLabourItemGroups = async (): Promise<LabourItemGroup[]> => {
  const response = await authenticatedApi.get<LabourItemGroup[]>(
    '/api/v1/labour-items/groups'
  );

  return response.data;
};

export const getLabourItemGroupDetails = async (
  id: string
): Promise<LabourItemGroupDetails> => {
  const response = await authenticatedApi.get<LabourItemGroupDetails>(
    `/api/v1/labour-items/groups/${id}`
  );

  return response.data;
};

export const updateLabourItemGroup = async (
  id: string,
  request: UpdateLabourItemGroupRequest
): Promise<void> => {
  await authenticatedApi.put(`/api/v1/labour-items/groups/${id}`, request);
};

export const updateGroupLabourItems = async (
  id: string,
  request: UpdateGroupLabourItemsRequest
): Promise<void> => {
  await authenticatedApi.put(
    `/api/v1/labour-items/groups/${id}/labour-items`,
    request
  );
};

export const deleteLabourItemGroup = async (id: string): Promise<void> => {
  await authenticatedApi.delete(`/api/v1/labour-items/groups/${id}`);
};
